import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import LabelText from '../LabelText';
import PanelInputField from '../PanelInputField';
import ArtStyleSlider from './ArtStyleSlider';
const ArtStyleField = ()=>{
    const { t } = useTranslation('dreamup');
    const groupLabelId = useUniqueId();
    return /*#__PURE__*/ React.createElement(PanelInputField, {
        rootTag: "div",
        role: "radiogroup",
        "aria-labelledby": groupLabelId,
        label: /*#__PURE__*/ React.createElement(LabelText, {
            id: groupLabelId
        }, t('dreamup.header.settingsPanel.artStyle.label')),
        input: /*#__PURE__*/ React.createElement(ArtStyleSlider, null)
    });
};
ArtStyleField.displayName = 'ArtStyleField';
export default ArtStyleField;

//# sourceMappingURL=ArtStyleField.js.map